import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalFooter from 'LuxKit/Modal/ModalFooter'

import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import PriceChangeViewV2 from 'components/Common/PriceChangeView/PriceChangeViewV2'

interface Props {
  oldDisplayPrice: number
  newDisplayPrice: number
  oldPropertyFees: number
  newPropertyFees: number
}

function BedbankChangePriceModal({
  oldDisplayPrice,
  newDisplayPrice,
  oldPropertyFees,
  newPropertyFees,
}: React.PropsWithChildren<Props>) {
  const intl = useIntl()
  const { resolve } = useModalElementContext<boolean | undefined>()

  const onAcceptNewPrice = useCallback(() => resolve(true), [resolve])

  return (
    <ModalBase size="S">
      <ModalHeader
        title="Price Update"
      />
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={24}>
            <BodyText as="p" variant="large">
              {intl.formatMessage({
                id: 'kclsBhMgyY',
                defaultMessage: 'The price of your package has changed due to updated availability. Please review the new price and accept it to continue.',
                description: 'Message informing user the package price changed and asking them to review',
              })}
            </BodyText>
            <PriceChangeViewV2
              oldPrice={oldDisplayPrice}
              newPrice={newDisplayPrice}
              oldPropertyFees={oldPropertyFees}
              newPropertyFees={newPropertyFees}
            />
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: intl.formatMessage({
            id: 'OPwHqQs3uE',
            defaultMessage: 'Accept updated price',
            description: 'Button text to accept updated price',
          }),
          onClick: onAcceptNewPrice,
        }}
        secondaryActionProps={{
          children: intl.formatMessage({
            id: 'BwNTnSt0dh',
            defaultMessage: 'Return to offer',
            description: 'Button text to return to offer',
          }),
        }}
      />
    </ModalBase>
  )
}

export default BedbankChangePriceModal
